import React, {Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import BaseElectronicSign from "./BaseElectronicSign";


class SmartId extends BaseElectronicSign {
    constructor(props) {
        super(props);

        this.get_token_url = this.getTokenUrl(props);
        this.get_token_status_url = this.getTokenStatusUrl(props);

        this.startPingingForLogin = this.startPingingForLogin.bind(this);
        this.startSign = this.startSign.bind(this);
        this.waitingResult = this.waitingResult.bind(this);
    }

    getTokenUrl(props) {
        if (props.application_token !== undefined) {
            return '/api/process/'+props.application_token+'/sign/smartid/token';
        } else if (props.file_token !== undefined) {
            return '/api/remote_sign/' + props.file_token + '/smartid/token';
        }

        return null
    }

    getTokenStatusUrl(props) {
        if (props.application_token !== undefined) {
            return '/api/process/'+props.application_token+'/sign/smartid/status';
        } else if (props.file_token !== undefined) {
            return '/api/remote_sign/' + props.file_token + '/smartid/status';
        }

        return null
    }

    render() {
        return (
            <div>
                {!this.state.hasCode ?
                    <Fragment>
                        <div
                            className="form-group col-12 d-flex justify-content-center mt-3">
                            <button
                                type='button'
                                className="btn btn-primary btn-lg"
                                onClick={ this.startSign }
                                disabled={this.state.isSubmitting}
                            >
                                {this.props.t('forms.sign.smartId') }
                            </button>
                        </div>

                        {this.state.error_msg.length > 0 ? <div className="col-12 d-flex justify-content-center mt-3">
                            <p>
                                { this.state.error_msg}
                            </p>
                        </div> : ''}
                    </Fragment>

                    : <Fragment>{this.waitingResult()}</Fragment>
                }
            </div>
        );
    };

}

export default withTranslation()(SmartId);
